/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MadrasaTermDataImportRequest } from '../models/MadrasaTermDataImportRequest';
import type { TermDataImportNextStageResponse } from '../models/TermDataImportNextStageResponse';
import type { TermDataImportRequest } from '../models/TermDataImportRequest';
import type { TermDataImportResponse } from '../models/TermDataImportResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TermDataImportRestControllerService {
  /**
   * madrasaSessionImport
   * @returns TermDataImportResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static madrasaSessionImportUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: MadrasaTermDataImportRequest;
  }): CancelablePromise<TermDataImportResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/term-data-import/madrasa-session-import',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getNextStage
   * @returns TermDataImportNextStageResponse OK
   * @throws ApiError
   */
  public static getNextStageUsingGet({
    termId,
  }: {
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<TermDataImportNextStageResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/term-data-import/progress',
      query: {
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * stageFourImports
   * @returns TermDataImportResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static stageFourImportsUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: TermDataImportRequest;
  }): CancelablePromise<TermDataImportResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/term-data-import/stage-four',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * stageOneImports
   * @returns TermDataImportResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static stageOneImportsUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: TermDataImportRequest;
  }): CancelablePromise<TermDataImportResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/term-data-import/stage-one',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * stageThreeImports
   * @returns TermDataImportResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static stageThreeImportsUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: TermDataImportRequest;
  }): CancelablePromise<TermDataImportResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/term-data-import/stage-three',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * stageTwoImports
   * @returns TermDataImportResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static stageTwoImportsUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: TermDataImportRequest;
  }): CancelablePromise<TermDataImportResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/term-data-import/stage-two',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
